import { InvoiceType, TransactionType } from "@gymflow/types";

import { RevenueCategoryKey, RevenueCategoryType } from "./types";

export const REVENUE_CATEGORY_MAP: Record<
  RevenueCategoryKey,
  RevenueCategoryType
> = {
  Membership: "MEMBERSHIP",
  CreditPack: "SESSION_PACK",
  Product: "PRODUCT_ORDER",
};

export const INVOICE_TYPE_DISPLAY_MAP: Partial<Record<InvoiceType, string>> = {
  SESSION_PACK: "Credit Pack",
};

export const TRANSACTION_TYPE_DISPLAY_MAP: Partial<
  Record<TransactionType, string>
> = {
  CREDIT: "Payment",
  REFUND_DEBIT: "Refund",
};
